<template>
  <div>
    <h3 class="text-lg font-semibold">Personal Information</h3>
    <ul class="my-2">
      <li class="mb-1 text-sm text-gray-500">
        <b>Occupation:</b>
        {{
          data["known_for_department"] === "Acting"
            ? data["gender"] === 1
              ? "Actress"
              : "Actor"
            : data["known_for_department"]
        }}
      </li>
      <li class="mb-1 text-sm text-gray-500">
        <b>Birthday:</b>
        {{
          data["deathday"]
            ? dateFormat(data["birthday"])
            : formatDOB(data["birthday"])
        }}
      </li>
      <li class="mb-1 text-sm text-gray-500" v-if="data.deathday">
        <b>Death day:</b>
        {{ formatDOB(data["deathday"]) }}
      </li>
      <li class="mb-1 text-sm text-gray-500">
        <b>Place of birth:</b> {{ data["place_of_birth"] }}
      </li>
      <li class="mb-1 text-sm text-gray-500" v-if="data.also_known_as">
        <b>Also known as:</b> {{ commaList(data["also_known_as"]) }}
      </li>
      <li class="mb-1 text-sm text-gray-500"></li>
    </ul>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "personal-info",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup() {
    const formatDOB = date => {
      const dob = moment(date).format("DD MMM, YYYY");
      const age = moment.duration(moment().diff(moment(date))).years();

      return `${dob} ( ${age} years old )`;
    };

    return {
      formatDOB
    };
  }
};
</script>

<style></style>
